import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let InvitationOption: LazyOption = createLazyOption(
    {
        key: 'invitation',
        titleStringKey: 'optionTitle_invitation',
        searchTermsStringKey: 'optionTitle_invitation',
        isHidden: () => !isFeatureEnabled('cal-event-invitation-setting'),
        allowedOptionKeys: ['CalendarProcessing'],
    },
    lazyFullModule,
    m => m.default
);
export default InvitationOption;
